// this is copied from Parcel as a hack to get the current URL of the
// current script. This is super useful, as it allows us to fetch related
// bundle things without knowing what environment we are in.
// https://github.com/parcel-bundler/parcel/blob/v2/packages/core/utils/src/bundle-url.js
//
// We should probably delete this once we move off of CSS modules in favor of
// direct CSS imports.
function getBaseURL(url: string) {
  return (
    ("" + url).replace(
      /^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/,
      "$1"
    ) + "/"
  );
}

let bundleURL: string | null = null;

export function getBundleURL(): string {
  if (bundleURL) {
    return bundleURL;
  }

  try {
    throw new Error();
  } catch (err: unknown) {
    var matches = ("" + (err as Error).stack).match(
      /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g
    );
    if (matches) {
      bundleURL = getBaseURL(matches[0]);
      return bundleURL;
    }
  }

  return "/";
}
